import { FC } from 'react';
import classNames from 'classnames';
import { IconButton, IconButtonProps } from '@lambdacurry/component-library';

export interface BackButtonProps extends Omit<IconButtonProps, 'icon'> {}

export const BackButton: FC<BackButtonProps> = ({ className, ...props }) => (
  <IconButton
    icon="arrowLeft"
    className={classNames(
      'back-button absolute left-0 top-1/2 !-translate-y-1/2 !text-brand-cool-green-500',
      className
    )}
    aria-label="Go back"
    data-cy="back-button"
    {...props}
  />
);
